// Branding fallbacks. Used when the super admin has not set a school name/logo
// in System Settings, or before the branding has loaded from the API.
import fallbackLogo from '@/assets/logo.png'

export const FALLBACK_SCHOOL_NAME = 'SchoolPay ERP'
export const FALLBACK_LOGO = fallbackLogo

// The SaaS product itself (the platform apex site + console), distinct from any
// individual school's branding.
export const PLATFORM_NAME = 'SkulKit'
export const PLATFORM_LOGO = fallbackLogo

// Currency used across the app when the super admin has not chosen one in
// System Settings (or before branding has loaded from the API).
export const FALLBACK_CURRENCY = { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', locale: 'en-NG' }
